import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
// import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { Employee } from 'src/app/models/employee';
import { ApiService } from 'src/app/services/api.service';
import { SocketService } from 'src/app/services/socket.service';
import { EMPLOYE_TYPE, STORAGE } from 'src/app/constants/general.constant';
import { NavItemService } from '../sidebar/sidebar-data';
import { NotificationBellComponent } from 'src/app/components/notification-bell/notification-bell.component';

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
    selector: 'app-header',
    imports: [
        RouterModule,
        CommonModule,
        NgScrollbarModule,
        TablerIconsModule,
        MaterialModule,
        NotificationBellComponent,
    ],
    templateUrl: './header.component.html',
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any = {
    language: '',
    code: '',
    type: '',
    icon: '',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      type: 'ES',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
  ];

  user: Employee = {} as Employee;
  employeeType = EMPLOYE_TYPE
  @Output() optionsChange = new EventEmitter<AppSettings>();

  translate: any
  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translateServ: TranslateService,
    private apiServ: ApiService, private router: Router, private socketService: SocketService, public navItemService: NavItemService
  ) {
    apiServ.user$.subscribe((user: Employee) => {
      this.user = user;
      translateServ.setDefaultLang(user?.lang || 'es');
      this.selectedLanguage = this.languages.find((l) => l.code === (user?.lang || 'es')) || this.languages[0];
      this.translateServ.currentLoader.getTranslation(user?.lang || 'es').subscribe((translations) => {
        this.settings.setTranslateDataMethod(translations);
        this.translate = translations;
      });
    });
  }

  options = this.settings.getOptions();

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    window.localStorage.setItem(STORAGE.theme.key, theme);
    this.options.theme = theme;
    this.emitOptions();
  }

  changeLanguage(lang: any): void {
    window.localStorage.setItem(STORAGE.lang.key, lang.code);
    this.translateServ.use(lang.code);
    this.selectedLanguage = lang;
    
    this.apiServ.doEmployee('PUT', { _id: this.user._id, lang: lang.code }).then((res: any) => {
    }).catch(err => {
      console.log('err changeLanguage: ', err);
    })

    this.translateServ.currentLoader.getTranslation(lang.code).subscribe((translations) => {
      this.settings.setTranslateDataMethod(translations);
    });
  }

  logOut() {
    this.apiServ.logOutLocal().then( async (_: any) => {
      if(_) {
        this.socketService.disconnect()
        this.router.navigateByUrl('/auth/login')
      }
    }).catch(err => {
      // console.log('err LogOut: ', err);
    })
  }
}

@Component({
    selector: 'search-dialog',
    imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
    templateUrl: 'search-dialog.component.html'
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = [] as any[];

  navItemsData = this.navItems.filter((navitem) => navitem.displayName);

  filtered = this.navItemsData.find((obj) => {
    // return obj.displayName == this.searchinput;
  });
}
